import {useIsSoftFeatureToggleActive} from '@aboutyou/feature-flags';
import {Redirect, TEASER_PAGE_PATHNAME, useHistory} from '@aboutyou/router';
import React, {FC} from 'react';

export function withLaunchTeaserRedirect<T>(
  Component: React.ComponentType<React.PropsWithChildren<T>>,
) {
  const WrapperComponent: FC<React.PropsWithChildren<T>> = props => {
    const isLaunchTeaserPageActive = useIsSoftFeatureToggleActive(
      'big_bang_launch_teaser_page',
    );
    const searchParams = useHistory().location.search;

    if (isLaunchTeaserPageActive) {
      const redirectUrl = `${TEASER_PAGE_PATHNAME}${searchParams}`;
      return <Redirect to={redirectUrl} />;
    }

    return <Component {...props} />;
  };

  return WrapperComponent;
}
